import { FrameWorkFormatDate, FrameWorkGetPrimaryColorButton, FrameWorkGetSecundaryColorButton, FrameWorkHideAlert, FrameWorkMessageAceptCancel, FrameWorkMessageErrorAlert, FrameWorkSimpleMessageState, OrdenExpressButtonSwitchSize, OrdenExpressGetCurrentUser, OrdenExpressIsAdmin, OrdenExpressNavegatePath, OrdenExpressValidateSecurity } from 'orden_express/frameWork/frameWork.js';
import { setDataOrderForShowAndEdit, setFilterDeliveryDate, setFilterDispatchDate, setFilterOrderText, setFilterRoute, setListOfProductsForBeginingOrder, setMessageOrdersRequested } from 'orden_express/orders/ordersActions';
import { requestGetOrdersRequested, requestSaveOrderState, requestSendEmailOrder,requestDeleteOrder } from 'orden_express/orders/ordersEpic';
import { setOriginRequestList } from 'orden_express/products/productsActions';
import { setDataRouteForEdit } from 'orden_express/routes/routesActions';
import { requestGetRoutes } from 'orden_express/routes/routesEpic.js';
import React from 'react';
import ReactDatetime from 'react-datetime';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Button, Card, CardBody, Col, FormGroup, Input, Row, UncontrolledTooltip } from 'reactstrap';
import { bindActionCreators } from 'redux';

const BUTTON_SIZE=1.1;
const BUTTON_SIZE_STYLE={ width: 40, height: 40 };

class OrderRequested extends React.Component {

 
  getInicialState = () => {
    return {
      alert: '',
      openedCollapses: ['collapseOne', 'collapse1'],
      ordersFiltered: [],
    };
  }

  constructor(props) {
    super(props);
    this.state = this.getInicialState();
    OrdenExpressValidateSecurity(this);
    this.startContent();
    //this.props.setFilterRoute({ value: '', label: 'Todos' });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.setState(this.getInicialState());
      this.startContent();
    }
    if (this.props.ordersReducerState.messageOrdersRequested !== prevProps.ordersReducerState.messageOrdersRequested) {
      this.processMessageState(this.props.ordersReducerState.messageOrdersRequested);
    }
  }

  startContent = () => {
    this.props.setMessageOrdersRequested(1);
    this.props.requestGetOrdersRequested(OrdenExpressGetCurrentUser(this));
    this.props.requestGetRoutes();
    this.applyFilters();
  }

  nameOfFieldTextSearchCategoryFilter = (pValue) => {
    if (pValue) {
      return pValue;
    }
    return '';
  }

  applyFiltersDeliveryDate = (pData, pFilter) => {
    if (pFilter === undefined) {
      return pData;
    }
    if ((pFilter + '').length > 10) {
      pFilter = FrameWorkFormatDate(pFilter, '-')
    }
    pFilter = (pFilter + '').trim();
    if (pFilter === '') {
      return pData;
    }
    var result = [];
    var pos = 0;
    var length = pData.length;
    while (pos < length) {
      var pOrder = pData[pos];
      var localOrder = pOrder;
      if (this.getDateFormat(localOrder.deliveryDate, '-').includes(pFilter)) {
        result.push(pOrder);
      }
      pos++;
    }
    return result;
  }

  applyFiltersDispatchDate = (pData, pFilter) => {

    if (pFilter === undefined) {
      return pData;
    }
    if ((pFilter + '').length > 10) {
      pFilter = FrameWorkFormatDate(pFilter, '-')
    }
    pFilter = (pFilter + '').trim();
    if (pFilter === '') {
      return pData;
    }
    var result = [];
    var pos = 0;
    var length = pData.length;
    while (pos < length) {
      var pOrder = pData[pos];
      var localOrder = pOrder;
      if (this.getDateFormat(localOrder.dispatchDate, '-').includes(pFilter)) {
        result.push(pOrder);
      }
      pos++;
    }
    /*pData.map((pOrder) => {
      var localOrder = pOrder;
      if (this.getDateFormat(localOrder.dispatchDate, '-').includes(pFilter)) {
        result.push(pOrder);
      }
    });*/
    return result;
  }

  applyFiltersRoute = (pData, pFilter) => {

    if (pFilter === undefined) {
      return pData;
    }
    var result = [];
    var filter = pFilter.label;
    if (filter === 'Todos') {
      return pData;
    }
    if (filter === 'Sin Asignar') {
      filter = null;
    }
    var pos = 0;
    var length = pData.length;
    while (pos < length) {
      var pOrder = pData[pos];
      if (pOrder.routeName === filter) {
        result.push(pOrder);
      }
      pos++;
    }
    /*pData.map((pOrder, pIndexOrder) => {
      if (pOrder.routeName === filter) {
        result.push(pOrder);
      }
    });*/
    return result;
  }

  applyFilters = (pContent) => {
    try {
      var filter = this.props.ordersReducerState.filterOrderText.toUpperCase();
      var result = [];
      var pos = 0;
      var length = pContent.length;
      while (pos < length) {
        var pOrderRequested = pContent[pos];
        var localOrder = pOrderRequested;
        var localUser = localOrder.user;
        var localDeliveryPoint = localUser.deliveryPoints[0];
        var localText =
          (localUser.identification + ' ' +
            localUser.name + ' ' +
            localUser.phone + ' ' +
            localUser.email + ' ' +
            localDeliveryPoint.name + ' ' +
            localDeliveryPoint.cityName + ' ' +
            localDeliveryPoint.address + ' ' +
            this.getDateFormat(localOrder.deliveryDate) + ' ' +
            this.getDateFormat(localOrder.dispatchDate) + ' ' +
            this.getDateFormat(localOrder.deliveryDate, '-') + ' ' +
            this.getDateFormat(localOrder.dispatchDate, '-') + ' kilos ' +
            localOrder.id + ' ' +
            (localOrder.active === 1 || localOrder.active === true ? 'Activo' : 'Inactivo') + ' ' +
            (localOrder.packed === 1 || localOrder.packed === true ? 'Alistado' : 'Sin alistar') + ' ' +
            (localOrder.dispatched === 1 || localOrder.dispatched === true ? 'Despachado' : 'Sin despachar')
          ).toUpperCase();
        if (localText.includes(filter)) {
          result.push(pOrderRequested);
        }
        pos++;
      }
      /*pContent.map((pOrderRequested) => {
         var localOrder = pOrderRequested;
         var localUser = localOrder.user;
         var localDeliveryPoint = localUser.deliveryPoints[0];
         var localText =
           (localUser.identification + ' ' +
             localUser.name + ' ' +
             localUser.phone + ' ' +
             localUser.email + ' ' +
             localDeliveryPoint.name + ' ' +
             localDeliveryPoint.cityName + ' ' +
             localDeliveryPoint.address + ' ' +
             this.getDateFormat(localOrder.deliveryDate) + ' ' +
             this.getDateFormat(localOrder.dispatchDate) + ' ' +
             this.getDateFormat(localOrder.deliveryDate, '-') + ' ' +
             this.getDateFormat(localOrder.dispatchDate, '-') + ' kilos ' +
             localOrder.id + ' ' +
             (localOrder.active === 1 || localOrder.active === true ? 'Activo' : 'Inactivo') + ' ' +
             (localOrder.packed === 1 || localOrder.packed === true ? 'Alistado' : 'Sin alistar') + ' ' +
             (localOrder.dispatched === 1 || localOrder.dispatched === true ? 'Despachado' : 'Sin despachar')
           ).toUpperCase();
         if (localText.includes(filter)) {
           result.push(pOrderRequested);
         }
       });*/
    } catch (__) {
      return pContent;
    }
    return result;
  }

  toggle = () => {
    this.setState({
      navBarIsOpen: !this.state.navBarIsOpen
    });
  }

  renderFilters = () => {
    return (
      <FormGroup >
        <Input
          type='text'
          placeholder='Buscar'
          id='idfilterText'
          value={this.props.ordersReducerState.filterOrderText}
          onChange={(newtext) => { this.props.setFilterOrderText(newtext.target.value) }}
        />
      </FormGroup>
    )
  }

  renderFiltersDispatchDate = () => {
    return (
      <FormGroup>
        <ReactDatetime
          style={{ width: '100%' }}
          inputProps={{
            className: 'form-control',
            placeholder: 'Fecha de despacho',
            readOnly: false
          }}
          value={this.props.ordersReducerState.filterDispatchDate}
          readOnly={true}
          dateFormat='YYYY-MM-DD'
          onChange={(value) => { this.props.setFilterDispatchDate(value) }}
          timeFormat={false}
          closeOnSelect={true}
        />
      </FormGroup>
    )
  }

  renderFiltersDeliveryDate = () => {
    return (
      <FormGroup>
        <ReactDatetime
          inputProps={{
            className: 'form-control',
            placeholder: 'Fecha de entrega',
            readOnly: false
          }}
          value={this.props.ordersReducerState.filterDeliveryDate}
          readOnly={true}
          dateFormat='YYYY-MM-DD'
          onChange={(value) => { this.props.setFilterDeliveryDate(value) }}
          timeFormat={false}
          closeOnSelect={true}
        />
      </FormGroup>
    )
  }

  sendToEditRoute = (pData = null) => {
    this.props.setDataRouteForEdit(pData);
    //this.props.history.push('/admin/routesForm');
    OrdenExpressNavegatePath(this, 'routesForm');
  }

  sendToEditOrderRequested = (pData = null) => {
    this.props.setDataOrderForShowAndEdit(pData);
    //this.props.history.push('/admin/editOrder');
    OrdenExpressNavegatePath(this, 'editOrder');
  }

  renderheaderButtons = () => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <div className='text-right'>
          <Button
            color={FrameWorkGetPrimaryColorButton()}
            className='btn-round mb-1 ml-6'
            onClick={() => {
              this.sendToEditRoute();
            }
            }
          >
            <i className='fa fa-map text-white' />
            {'+ Nueva ruta'}
          </Button>
        </div>
      )
    }
    return (<></>);
  }

  changeStateOrder = (pField, pValue, pOrder) => {
    if (!OrdenExpressIsAdmin(this)) {
      return;
    }
    if (pValue === true) {
      pValue = 1;
    } else if (pValue === false) {
      pValue = 0;
    }
    switch (pField) {
      case 'packed':
        pField = 0;
        pOrder.packed = pValue;
        break;
      case 'dispatched':
        pField = 1;
        pOrder.dispatched = pValue;
        break;
      case 'received':
        pField = 2;
        pOrder.received = pValue;
        break;
      case 'route':
        pField = 3;
        pOrder.route = pValue;
        break;
      case 'dispatchDate':
        pField = 4;
        pOrder.dispatchDate = pValue * 1;
        break;
      case 'deliveryDate':
        pField = 5;
        pOrder.deliveryDate = pValue * 1;
        break;
      case 'orderPosition':
        pField = 6;
        pOrder.orderPosition = pValue;
        break;
      default:
        break;
    }
    pOrder.fieldUpdateState = pField;
    this.props.setMessageOrdersRequested(1);
    this.props.requestSaveOrderState(pOrder);
  }

  getDateFormat = (pData, pSeparator = '/') => {
    return FrameWorkFormatDate(pData, pSeparator);
  }

  /**
   * Controla la secuencia de estados para visualizar
   * los mensajes en el proceso
   */
  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Mostrando Órdenes', 'Se está procesando ...');
        break;
      case 2:
        FrameWorkHideAlert(this);
        this.props.setMessageOrdersRequested(0);
        break;
      case 3:
        var localMessageError = this.props.ordersReducerState.responseGetOrdersRequested;
        FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
        console.error(localMessageError)
        break;
      default:
        FrameWorkHideAlert(this);
        this.props.setMessageOrdersRequested(0);
        break;
    }
  }

  closeOrderConfirmed = (pData) => {
    this.changeStateOrder('received', true, pData);
  }

  sendMailOrderConfirmed = (pData) => {
    this.props.setMessageOrdersRequested(1);
    this.props.requestSendEmailOrder(pData.id);
  }

  deletelOrderConfirmed = (pData) => {
    this.props.setMessageOrdersRequested(1);
    this.props.requestDeleteOrder(pData.id);
  }


  askIfWantTodeleteOrder = (pData) => {
    FrameWorkMessageAceptCancel(
      this,
      'Borrar solicitud ' + pData.id,
      '¿Desea Borrar la solicitud seleccionada?',
      this.deletelOrderConfirmed,
      null,
      pData,
      null,
      'alert'
    );
  }

  askIfWantToCloseOrder = (pData) => {
    FrameWorkMessageAceptCancel(
      this,
      'Finalizar solicitud ' + pData.id,
      '¿Desea Finalizar la solicitud seleccionada?',
      this.closeOrderConfirmed,
      null,
      pData,
      null,
      'alert'
    );
  }

  askIfWantToSendMailOrder = (pData) => {
    FrameWorkMessageAceptCancel(
      this,
      'Enviar correo solicitud ' + pData.id,
      '¿Desea Enviar el correo con los datos de la solicitud?',
      this.sendMailOrderConfirmed,
      null,
      pData,
      null,
      'alert'
    );
  }

  getRoutesForEditIntOrder = (localRoutes) => {
    var result = [{ value: '', label: '' }]
    if (OrdenExpressIsAdmin(this)) {
      result =
        [{ value: ''.id, label: 'Sin Asignar' }].concat(
          localRoutes.map((itemRoute, indexRoute) => {
            return (
              { value: itemRoute.id, label: itemRoute.name, isDisabled: itemRoute.active !== 1 }
            )
          })
        );
    }
    return result;
  }

  renderSelectRoute = (pOrderRequested) => {
    var localRoutes = [];
    try {
      var pos = 0;
      var length = this.props.routesReducerState.responseGetRoutes.result.length;
      while (pos < length) {
        var itemRoute = this.props.routesReducerState.responseGetRoutes.result[pos];
        if (itemRoute.active === 1) {
          localRoutes.push(itemRoute);
        }
        pos++;
      }
    } catch (__) { }
    return (
      <Select
        className='react-select'
        classNamePrefix='react-select'
        name='routeOrderRequested'
        placeholder='Seleccione la ruta'
        value={
          {
            value: pOrderRequested.routeName === null || pOrderRequested.routeName === undefined ? '' : pOrderRequested.route,
            label: pOrderRequested.routeName === null || pOrderRequested.routeName === undefined ? 'Sin asignar' : pOrderRequested.routeName
          }
        }
        options={
          this.getRoutesForEditIntOrder(localRoutes)
        }
        onChange={value => {
          this.changeStateOrder('route', value.value, pOrderRequested);
        }
        }
      />
    );
  }

  renderViewOptions = () => {
    var localRoutes = [];
    try {
      var pos = 0;
      var length = this.props.routesReducerState.responseGetRoutes.result.length;
      while (pos < length) {
        var itemRoute = this.props.routesReducerState.responseGetRoutes.result[pos];
        if (itemRoute.active === 1) {
          localRoutes.push(itemRoute);
        }
        pos++;
      }
      /*this.props.routesReducerState.responseGetRoutes.result.map((itemRoute) => {
        if (itemRoute.active === 1) {
          localRoutes.push(itemRoute);
        }
      });*/
    } catch (__) { }
    return (
      <Select
        className='react-select mb-2'
        classNamePrefix='react-select'
        id='idViewByRoute'
        name='viewByRoute'
        placeholder='Seleccione la ruta'
        //defaulValue={{ value: '@', label: 'Todos' }}
        value={this.props.ordersReducerState.filterRoute || { value: '@', label: 'Todos' }}
        options={[{ value: '@', label: 'Todos' }, { value: '', label: 'Sin Asignar' }].concat(
          localRoutes.map((itemRoute, indexRoute) => {
            return (
              { value: itemRoute.id, label: itemRoute.name, isDisabled: itemRoute.active !== 1 }
            )
          })
        )
        }
        onChange={(value) => {
          this.props.setFilterRoute(value);
        }
        }
      />
    );
  }

  renderAdjustEmailPresentation = (pData) => {
    try {
      var partsOfEmail = pData.split('@');
      return (
        <div className='d-inline-block'>
          <div className='d-inline-block'>
            {partsOfEmail[0]}
          </div>
          <div className='d-inline-block'>
            {'@'}
          </div>
          <div className='d-inline-block'>
            {partsOfEmail[1]}
          </div>
        </div>
      )
    } catch (__) { }
    return (<></>);
  }

  renderButtonCloseOrder = (localOrder, indexListOrder) => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <div className='d-inline-block'>
          <Button
            className='btn-icon btn-round mt-2 mb-0 ml-0 pl-0'
            color={FrameWorkGetSecundaryColorButton()}
            id={`idEndOrder${indexListOrder}`}
            type='button'
            outline
            style={BUTTON_SIZE_STYLE}
            onClick={value => {
              this.askIfWantToCloseOrder(localOrder);
            }}
          >
            <i className='fa fa-calendar-check-o' />
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`idEndOrder${indexListOrder}`}
          >
            {'Cierre definitivo de la orden'}
          </UncontrolledTooltip>
        </div>)
    }
    return (<></>);
  }

  renderButtonDeleteOrder = (localOrder, indexListOrder) => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <div className='d-inline-block'>
          <Button
            className='btn-icon btn-round mt-2 mb-0 ml-0 pl-0'
            color={FrameWorkGetPrimaryColorButton()}
            id={`idDeleteOrder${indexListOrder}`}
            type='button'
            outline
            style={BUTTON_SIZE_STYLE}
            onClick={value => {
              this.askIfWantTodeleteOrder(localOrder);
            }}
          >
            <i className='fa fa-trash-o' />
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`idDeleteOrder${indexListOrder}`}
          >
            {'Borra la orden del sistema'}
          </UncontrolledTooltip>
        </div>)
    }
    return (<></>);
  }

  renderButtonSendEmail = (localOrder, indexListOrder) => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <div className='d-inline-block'>
          <Button
            className='btn-icon btn-round mt-2 mb-0 ml-0 pl-0'
            color={FrameWorkGetPrimaryColorButton()}
            id={`idSendEndOrder${indexListOrder}`}
            type='button'
            outline
            style={BUTTON_SIZE_STYLE}
            onClick={value => {
              this.askIfWantToSendMailOrder(localOrder);
            }}
          >
            <i className='fa fa-send' />
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`idSendEndOrder${indexListOrder}`}
          >
            {'Enviar correo con el contenido de la orden'}
          </UncontrolledTooltip>
        </div>)
    }
    return (<></>);
  }

  renderSwitchStateOrder = (localOrder, indexListOrder) => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <>
          <Col xs={BUTTON_SIZE}>
            <div className='d-inline-block mt-2 mb-0'>
              <div className='d-inline-block mt-0 mb-0 ml-2'>
                {OrdenExpressButtonSwitchSize('packed', 'On', 'Off', localOrder, this.changeStateOrder, BUTTON_SIZE_STYLE)}
              </div>
              <br />
              {this.renderLabelButton('Alista')}
            </div>
          </Col>
          <Col xs={BUTTON_SIZE}>
            <div className='d-inline-block mt-2 mb-0'>
              <div className='d-inline-block mt-0 mb-0 ml-2'>
                {OrdenExpressButtonSwitchSize('dispatched', 'On', 'Off', localOrder, this.changeStateOrder, BUTTON_SIZE_STYLE)}
              </div>
              <br />
              {this.renderLabelButton('Despa')}
            </div>
          </Col>
        </>
      )
    }
    return (<div></div>)
  }

  moveToPositionOrder = (pPositionTo, pIndexPosition, pTotalElements, pOrderBefore, pLocalOrder, pAfterOrder) => {
    var tempPosition;
    switch (pPositionTo) {
      case 1://up
        try {
          if (pOrderBefore['id']) {
            tempPosition = pLocalOrder.orderPosition;
            pLocalOrder.orderPosition = pOrderBefore.orderPosition;
            pOrderBefore.orderPosition = tempPosition;
            if (pLocalOrder.orderPosition === pOrderBefore.orderPosition) {
              pLocalOrder.orderPosition++;
            }
            this.changeStateOrder('orderPosition', pLocalOrder.orderPosition, pLocalOrder);
            this.changeStateOrder('orderPosition', pOrderBefore.orderPosition, pOrderBefore);
          }
        } catch (__) { }

        break;
      case 2://down
        try {
          if (pAfterOrder['id']) {
            tempPosition = pLocalOrder.orderPosition;
            pLocalOrder.orderPosition = pAfterOrder.orderPosition;
            pAfterOrder.orderPosition = tempPosition;
            if (pLocalOrder.orderPosition === pAfterOrder.orderPosition) {
              pLocalOrder.orderPosition--;
            }
            this.changeStateOrder('orderPosition', pLocalOrder.orderPosition, pLocalOrder);
            this.changeStateOrder('orderPosition', pAfterOrder.orderPosition, pAfterOrder);
          }
        } catch (__) { }

        break;

      default:
        break;
    }
  }

  renderRouteFilter = () => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <>
          <Col md='3'>
            <div className='framework-flexcontainer'>
              <div>
                <b>Ruta asignada</b>
              </div>
              <div className='text-right framework-flex-rigth'>
                <Button
                  className='btn-icon btn-round mt-0 mb-0'
                  color={FrameWorkGetPrimaryColorButton()}
                  type='button'
                  outline
                  size='xs'

                  onClick={value => {
                    this.props.setFilterRoute({ value: '@', label: 'Todos' });
                  }}
                >
                  <i className='fa fa-trash' />
                </Button>
              </div>
            </div>
          </Col>
          <Col>
            {this.renderViewOptions()}
          </Col>
        </>
      )
    }
    return (<></>);
  }

  allowDrop = (ev) => {
    // console.info('allowDrop', ev);
    ev.preventDefault();
  }

  drag = (ev, pOrder) => {
    //console.info('drag', ev);
    ev.dataTransfer.setData('order', JSON.stringify(pOrder));
  }

  drop = (ev, pOrder) => {

    ev.preventDefault();
    //var origin = JSON.parse(ev.dataTransfer.getData('order'));
    //console.info('drop origin', origin);
    //console.info('drop destiny', pOrder);
    //ev.target.appendChild(document.getElementById(data));
  }

  renderLabelButton = (textLabel, validate=true) => {
    var showContent=true;
    if(validate){
      showContent=OrdenExpressIsAdmin(this);
    }
    if(showContent){
      return (
        <div className='d-inline-block mr-1 ml-3'>
          <font size="1">
            <b>{textLabel}</b>
          </font>
        </div>);
    } 
    return (<></>) 
  }

  renderOrderPositionButtons = (localOrder, indexListOrder, localOrders, totalElementLists) => {
    if (!OrdenExpressIsAdmin(this)) {
      return (<></>);
    }
    return (
      <>
        <Button
          className='btn-icon btn-round d-line-block mt-0'
          id={`upPosition${indexListOrder}`}
          color={FrameWorkGetPrimaryColorButton()}
          type='button'
          outline
          size='lg'

          onClick={value => {
            var orderBefore = {};
            var orderAfter = {};
            try {
              orderBefore = localOrders[indexListOrder - 1]
            } catch (__) { }
            try {
              orderAfter = localOrders[indexListOrder + 1]
            } catch (__) { }

            this.moveToPositionOrder(1, indexListOrder, totalElementLists, orderBefore, localOrder, orderAfter);
          }}
        >
          <i className='fa fa-chevron-up' />
        </Button>
        <UncontrolledTooltip
          delay={0}
          target={`upPosition${indexListOrder}`}
        >
          {'Desplazar hacia arriba'}
        </UncontrolledTooltip>
        <br />
        <Button
          className='btn-icon btn-round d-line-block mt-0'
          id={`downPosition${indexListOrder}`}
          color={FrameWorkGetPrimaryColorButton()}
          type='button'
          outline
          size='lg'

          onClick={value => {
            var orderBefore = {};
            var orderAfter = {};
            try {
              orderBefore = localOrders[indexListOrder - 1]
            } catch (__) { }
            try {
              orderAfter = localOrders[indexListOrder + 1]
            } catch (__) { }

            this.moveToPositionOrder(2, indexListOrder, totalElementLists, orderBefore, localOrder, orderAfter);
          }}
        >
          <i className='fa fa-chevron-down' />
        </Button>
        <UncontrolledTooltip
          delay={0}
          target={`downPosition${indexListOrder}`}
        >
          {'Desplazar hacia abajo'}
        </UncontrolledTooltip>
      </>
    );
  }

  verifyWeightToShow = (localOrders) => {
    var totalWeight = 0;
    var pos = 0;
    var length = localOrders.length;
    while (pos < length) {
      var itemListMapOrder = localOrders[pos];
      totalWeight += itemListMapOrder.weight;
      pos++;
    }
    /*localOrders.map((itemListMapOrder) => {
            totalWeight += itemListMapOrder.weight;
        });*/
    return totalWeight.toFixed(1);
  }

  render = () => {
    var totalWeight = 0;
    var localOrders = [];
    try {
      localOrders = this.applyFiltersDeliveryDate(this.applyFiltersDispatchDate(this.applyFilters(this.applyFiltersRoute(this.props.ordersReducerState.responseGetOrdersRequested.result || [], this.props.ordersReducerState.filterRoute)), this.props.ordersReducerState.filterDispatchDate), this.props.ordersReducerState.filterDeliveryDate);
    } catch (__) { }

    var totalWeightCalculateOut = this.verifyWeightToShow(localOrders);
    var lastIndex = 0;
    var totalElementLists = localOrders.length;
    return (
      <div className='content mt-5 mb-0'>
        {this.state.alert}
        <div className='framework-flexcontainer'>
          <div>
            <h4>{'Órdenes'}</h4>
          </div>
          <div className='text-right framework-flex-rigth'>
            {this.renderheaderButtons()}
          </div>
        </div>
        <div>
          <Card className='mt-1 mb-1'>
            <CardBody>
              <Row className='framework-v-center'>
                {this.renderRouteFilter()}
              </Row>
              <Row className='framework-v-center'>
                <Col md='3'>
                  <div className='framework-flexcontainer'>
                    <div>
                      <b>Fecha de despacho</b>
                    </div>
                    <div className='text-right framework-flex-rigth'>
                      <Button
                        className='btn-icon btn-round mt-0 mb-0'
                        color={FrameWorkGetPrimaryColorButton()}
                        type='button'
                        outline
                        size='xs'

                        onClick={value => {
                          this.props.setFilterDispatchDate('');
                        }}
                      >
                        <i className='fa fa-trash' />
                      </Button>
                    </div>
                  </div>


                </Col>
                <Col>
                  {this.renderFiltersDispatchDate()}
                </Col>

              </Row>
              <Row className='framework-v-center'>
                < Col md='3'>
                  <div className='framework-flexcontainer'>
                    <div>
                      <b>Fecha de entrega</b>
                    </div>
                    <div className='text-right framework-flex-rigth'>
                      <Button
                        className='btn-icon btn-round mt-0 mb-0'
                        color={FrameWorkGetPrimaryColorButton()}

                        type='button'
                        outline
                        size='xs'

                        onClick={value => {
                          this.props.setFilterDeliveryDate('');
                        }}
                      >
                        <i className='fa fa-trash' />
                      </Button>
                    </div>
                  </div>
                </Col>
                <Col>
                  {this.renderFiltersDeliveryDate()}
                </Col>
              </Row>
              <Row className='framework-v-center'>
                <Col md='3'>
                  <div className='framework-flexcontainer'>
                    <div>
                      <b>Filtro</b>
                    </div>
                    <div className='text-right framework-flex-rigth'>
                      <Button
                        className='btn-icon btn-round mt-0 mb-0'
                        color={FrameWorkGetPrimaryColorButton()}
                        type='button'
                        outline
                        size='xs'

                        onClick={value => {
                          this.props.setFilterOrderText('');
                        }}
                      >
                        <i className='fa fa-trash' />
                      </Button>
                    </div>
                  </div>
                </Col>
                <Col>
                  {this.renderFilters()}
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card
            className={`mt-0 mb-1 ${lastIndex % 2 === 0 ? 'bg-gray' : 'bg-white'}`}

          >
            <CardBody>
              {
                <b>Nº de órdenes</b>
              }{' '}
              {localOrders.length}
              <br />
              {
                <b>Peso totalizado</b>
              }{' '}
              {totalWeightCalculateOut}
              {' Kilos'}
            </CardBody>
          </Card>
        </div>
        {
          localOrders.map((itemListMapOrder, indexListOrder) => {

            var localOrder = itemListMapOrder;
            var localUser = localOrder.user || {};
            var localDeliveryPoint = {}
            if (localUser.deliveryPoints) localDeliveryPoint = localUser.deliveryPoints[0] || {};
            totalWeight += localOrder.weight;
            lastIndex = indexListOrder + 1;
            return (
              <>
                <div id={`div1${indexListOrder}`}
                //onDrop={(event) => { this.drop(event,itemListMapOrder) }}
                //onDragOver={(event) => { this.allowDrop(event,itemListMapOrder) }}
                >
                  <Card
                    key={`carIdUnique${indexListOrder}`}
                    className={`mt-0 mb-1 ${indexListOrder % 2 === 0 ? 'bg-white' : 'bg-gray'}`}
                  >
                    <CardBody key={`CardBody${indexListOrder}`}>
                      <Row key={`Row${indexListOrder}`}>
                        <Col key={`Col${indexListOrder}`}>
                          <div className='text-left framework-flexcontainer'>
                            <span style={{ width: '100%' }}>
                              <b>
                                {'Nº'}
                              </b>{' '}
                              {localOrder.id}
                              <div>
                                <Row>
                                  <Col xs='auto'>
                                    <b>
                                      {'Despacho'}
                                    </b>{' '}
                                  </Col>
                                  <Col>
                                    <FormGroup className='d-inline-block' style={{ width: '100%' }}>
                                      <ReactDatetime
                                        id={`idReactDatetimeDispatch${indexListOrder}`}
                                        inputProps={{
                                          className: 'form-control',
                                          placeholder: 'Fecha inicial',
                                          readOnly: true
                                        }}
                                        value={localOrder.dispatchDate}
                                        dateFormat='YYYY-MM-DD'
                                        onChange={(value) => { this.changeStateOrder('dispatchDate', value, localOrder) }}
                                        timeFormat={false}
                                        closeOnSelect={true}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </div>
                              <div>
                                <Row>
                                  <Col xs='auto'>
                                    <b>
                                      {'Entrega'}&nbsp;&nbsp;&nbsp;
                                    </b>
                                    {' '}
                                  </Col>
                                  <Col>
                                    <FormGroup className='d-inline-block' style={{ width: '100%' }}>
                                      <ReactDatetime
                                        id={`idReactDatetimeDelivery${indexListOrder}`}
                                        inputProps={{
                                          className: 'form-control',
                                          placeholder: 'Fecha inicial',
                                          readOnly: true
                                        }}
                                        value={localOrder.deliveryDate}
                                        dateFormat='YYYY-MM-DD'
                                        onChange={(value) => { this.changeStateOrder('deliveryDate', value, localOrder) }}
                                        timeFormat={false}
                                        closeOnSelect={true}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </div>
                            </span>
                            <span className='framework-flex-rigth text-right'>
                              {this.renderOrderPositionButtons(localOrder, indexListOrder, localOrders, totalElementLists)}
                            </span>
                          </div>
                          <div className='d-inline-block'>
                            <b>Cliente</b>{' '}
                            <div className='d-inline-block'>
                              {
                                localUser.typeIdentification + ': ' +
                                localUser.identification + ' ' +
                                localUser.name + ' ' +
                                localUser.phone
                              }
                              &nbsp;
                         </div>
                            {this.renderAdjustEmailPresentation(localUser.email)}
                          </div>
                          <div>
                            <b>Punto de entrega</b>{' '}
                            {
                              localDeliveryPoint.name + ' ' +
                              localDeliveryPoint.cityName + ' ' +
                              localDeliveryPoint.address
                            }
                          </div>
                          <div>
                            <b>Peso total</b>{' '}
                            {
                              localOrder.weight + ' Kilos'
                            }
                          </div>
                          <div>
                            <Row className='framework-v-center'>
                              <Col md='auto'>
                                <b>Ruta &nbsp;  &nbsp;  </b>{' '}
                              </Col>
                              <Col>
                                {this.renderSelectRoute(localOrder)}
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        {this.renderSwitchStateOrder(localOrder, indexListOrder)}
                        <Col xs={BUTTON_SIZE}>
                          <div className='d-inline-block mt-2 mb-0'>
                            <div className='d-inline-block mt-0 mb-0 ml-2'>
                              <Button
                                className='btn-icon btn-round mt-2 mb-0 ml-0 pl-0'
                                color={FrameWorkGetSecundaryColorButton()}
                                id={`idEditOrder${indexListOrder}`}
                                type='button'
                                outline
                                style={BUTTON_SIZE_STYLE}
                                onClick={value => {
                                  this.sendToEditOrderRequested(localOrder);
                                }}
                              >
                                <i className='fa fa-shopping-cart' />
                              </Button>
                              <UncontrolledTooltip
                                delay={0}
                                target={`idEditOrder${indexListOrder}`}
                              >
                                {'Ver detalle de la orden'}
                              </UncontrolledTooltip>
                            </div>
                            <br />
                            {this.renderLabelButton('Ver',false)}
                          </div>
                        </Col>
                        <Col xs={BUTTON_SIZE}>
                          <div className='d-inline-block mt-2 mb-0'>
                            <div className='d-inline-block mt-0 mb-0 ml-2'>
                              {this.renderButtonCloseOrder(localOrder, indexListOrder)}
                            </div>
                            <br />
                            {this.renderLabelButton('Cerrar')}
                          </div>
                        </Col>
                        <Col xs={BUTTON_SIZE}>
                          <div className='d-inline-block mt-2 mb-0'>
                            <div className='d-inline-block mt-0 mb-0 ml-2'>
                              {this.renderButtonSendEmail(localOrder, indexListOrder)}
                            </div>
                            <br />
                            {this.renderLabelButton('Email')}
                          </div>
                        </Col>
                        <Col xs={BUTTON_SIZE}>
                          <div className='d-inline-block mt-2 mb-0'>
                            <div className='d-inline-block mt-0 mb-0 ml-2'>
                              {this.renderButtonDeleteOrder(localOrder, indexListOrder)}
                            </div>
                            <br />
                            {this.renderLabelButton('Borrar')}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </>
            )
          })
        }
        <Card
          className={`mt-0 mb-1 ${lastIndex % 2 === 0 ? 'bg-white' : 'bg-gray'}`}
        >
          <CardBody>
            {
              <b>Nº de órdenes</b>
            }{' '}
            {localOrders.length}
            <br />
            {
              <b>Peso totalizado</b>
            }{' '}
            {totalWeight.toFixed(1)}
            {' Kilos'}
          </CardBody>
        </Card>
      </div>
    );
  }


}

const mapStateToProps = state => {
  return {
    ordersReducerState: state.ordersReducerState,
    routesReducerState: state.routesReducerState,
    loginReducerState: state.loginReducerState,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setMessageOrdersRequested: (messageOrdersRequested) => dispatch(setMessageOrdersRequested(messageOrdersRequested)),
    setListOfProductsForBeginingOrder: (listOfProductsForBeginingOrder) => dispatch(setListOfProductsForBeginingOrder(listOfProductsForBeginingOrder)),
    setOriginRequestList: (originRequestListsetOriginRequestList) => dispatch(setOriginRequestList(originRequestListsetOriginRequestList)),
    setFilterRoute: (filterRoute) => dispatch(setFilterRoute(filterRoute)),
    setFilterDispatchDate: (filterDispatchDate) => dispatch(setFilterDispatchDate(filterDispatchDate)),
    setFilterDeliveryDate: (filterDeliveryDate) => dispatch(setFilterDeliveryDate(filterDeliveryDate)),
    setFilterOrderText: (filterOrderText) => dispatch(setFilterOrderText(filterOrderText)),
    setDataRouteForEdit: (dataRouteForEdit) => dispatch(setDataRouteForEdit(dataRouteForEdit)),
    setDataOrderForShowAndEdit: (dataOrderForShowAndEdit) => dispatch(setDataOrderForShowAndEdit(dataOrderForShowAndEdit)),



    requestGetOrdersRequested: (dataUserGetRequest) => bindActionCreators(dispatch(requestGetOrdersRequested(dataUserGetRequest)), dispatch),
    requestSaveOrderState: (saveOrderState) => bindActionCreators(dispatch(requestSaveOrderState(saveOrderState)), dispatch),
    requestGetRoutes: () => bindActionCreators(dispatch(requestGetRoutes()), dispatch),
    requestSendEmailOrder: (idOrder) => bindActionCreators(dispatch(requestSendEmailOrder(idOrder)), dispatch),
    requestDeleteOrder: (idOrder) => bindActionCreators(dispatch(requestDeleteOrder(idOrder)), dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderRequested);